import { useRef } from 'react'
import { TimePicker } from '@web-lite/scroll-picker'
import i18next from 'i18next'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'

interface Props {
  startDate: Date
  endDate: Date
  onChangeDate: (date: Date) => void
  selectedDate: Date
  onSubmit: () => void
}
export function ScheduleForm({
  startDate,
  endDate,
  onChangeDate,
  selectedDate,
  onSubmit,
}: Props) {
  const startRef = useRef(startDate)
  const endRef = useRef(endDate)
  return (
    <>
      <TimePicker
        locale={i18next.language}
        onChange={onChangeDate}
        theme={null}
        end={endRef.current}
        selected={selectedDate}
        start={startRef.current}
      />
      <PrimaryButton
        sx={{ mt: '16px' }}
        text={t('chooseHallCallTimeModal.startAtChosenDate')}
        onClick={onSubmit}
      />
    </>
  )
}
